import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import {client} from '../../Client';
import Moment from 'moment';
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import {FormattedDate} from 'react-intl';
import ShowOptionalField from '../ShowOptionalField'
import ShowLocalNumber from '../ShowLocalNumber'
import CommesseDateCompactView from '../commesse/CommesseDateCompactView'

class ReportCommesseView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            column: null,
            direction: null,
        };
    }

    renderCompact(items) {

        let i = 0;
        return <div className="ep-outer-table">
            <div className="ep-inner-scrollable-table">

                <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'id' ? this.state.direction:null} >
                        ID
                    </Table.HeaderCell>
                    <Table.HeaderCell colSpan={2} collapsing={true} sorted={this.state.column === 'colore' ? this.state.direction : null} >
                        Colore
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'codice' ? this.state.direction : null} >
                        Codice
                    </Table.HeaderCell>
                    <Table.HeaderCell sorted={this.state.column === 'nome' ? this.state.direction : null} >
                        Nome
                    </Table.HeaderCell>
                    <Table.HeaderCell sorted={this.state.column === 'oggetto' ? this.state.direction : null} >
                        Oggetto
                    </Table.HeaderCell>
                    <Table.HeaderCell sorted={this.state.column === 'note' ? this.state.direction : null} >
                        Note aggiuntive
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true} textAlign='center' sorted={this.state.column === 'dataIncarico' ? this.state.direction:null} >
                        Incarico
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true} textAlign='center' sorted={this.state.column === 'altreDate' ? this.state.direction:null} >
                        Altre date
                    </Table.HeaderCell>
                    <Table.HeaderCell  sorted={this.state.column === 'cliente' ? this.state.direction:null} >
                        Cliente
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true}  textAlign='center' sorted={this.state.column === 'peso' ? this.state.direction:null} >
                        Peso
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true} textAlign='right' sorted={this.state.column === 'incassoPresunto' ? this.state.direction:null} >
                        Incasso presunto
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true} textAlign='center' sorted={this.state.column === 'conclusa' ? this.state.direction:null} >
                        Prestazione conclusa
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing={true} textAlign='center' sorted={this.state.column === 'archiviata' ? this.state.direction:null} >
                        Archiviata
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    items.map((item) => {

                        let infoGara = null;
                        if(item.idGara){
                            infoGara = (<em><br/>Gara: {item.idGara.anno}/{item.idGara.codice}</em>);
                        }
                        return <Table.Row key={i++}>
                            <Table.Cell>{item.idCommessa}</Table.Cell>
                            <Table.Cell collapsing={true}><div className="ui segment" style={{width:"30px", backgroundColor: item.colore}}></div></Table.Cell>
                            <Table.Cell collapsing={true}>{item.colore}</Table.Cell>
                            <Table.Cell collapsing={true} >{item.codice}{infoGara}</Table.Cell>
                            <Table.Cell>{item.nome}</Table.Cell>
                            <Table.Cell>{item.oggetto}</Table.Cell>
                            <Table.Cell>{item.note}</Table.Cell>
                            <Table.Cell collapsing={true} textAlign='center'>
                                {item.dataIncarico != null ?
                                    <FormattedDate
                                        value={item.dataIncarico}
                                        day="numeric"
                                        month="numeric"
                                        year="numeric"
                                    /> : <span></span>
                                }
                            </Table.Cell>
                            <Table.Cell collapsing={true}  textAlign='center' ><CommesseDateCompactView item={item}/></Table.Cell>
                            <Table.Cell>{item.ragioneSociale}, {item.indirizzo} {item.cap} {item.citta} {item.provincia} {item.stato} <ShowOptionalField label="P.IVA" value={item.piva}/> <ShowOptionalField label="C.Fisc." value={item.cfisc}/>
                            </Table.Cell>
                            <Table.Cell textAlign='right'><ShowLocalNumber value={item.incassoPresunto}/></Table.Cell>
                            <Table.Cell textAlign='center'>{item.peso}</Table.Cell>
                            <Table.Cell textAlign='center'>
                                {
                                    item.conclusa ?
                                        <label className="ui tiny red  label center floated">Chiusa</label>
                                        :
                                        <label className="ui tiny green  label center floated">Non chiusa</label>
                                }
                            </Table.Cell>
                            <Table.Cell textAlign='center'>
                                {
                                    item.archiviata ?
                                        <label className="ui tiny red  label center floated">Archiviata</label>
                                        :
                                        <label className="ui tiny green  label center floated">Non archiviata</label>
                                }
                            </Table.Cell>
                        </Table.Row>
                    })}
            </Table.Body>
        </Table>
            </div>
        </div>
    }

    render() {
        let items = this.props.items;
        if (items === undefined || items.length === 0){
            return null;
        }
        let tabledata = this.renderCompact(items);

        return <div>
            {tabledata}
            <div className="ui two columns grid">
                <div className="column">Stampa eseguita il <LocalDate data={Moment().format("YYYY-MM-DD")}/> alle ore <LocalTime data={Moment().format(Moment().ISO_8601)}/> da {client.getCurrentUser().nome}</div>
            </div>
        </div>
    }
}

export default ReportCommesseView;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesseView.js
 **/